import Hero from "./Hero";
import Team from "./Team";

function AboutPage() {
    return ( 
        <div>
            <Hero />
            <Team />
        </div>
     );
}

export default AboutPage;